import React from "react";

import { NIGHTMARES } from "../../data/pages";
import SectionTitle from "../general/SectionTitle";
import SmartLink from "../general/SmartLink";

//"Event Planning Giving You Nightmares?" box with the Build Your Event button - on most pages, as on Wix
const Nightmares = () => (
  <section className={"boxed-section"}>
    <div className={"container"}>
      <div className={"gold-box nightmares"}>
        <SectionTitle subtitle={NIGHTMARES.SUBTITLE}>{NIGHTMARES.TITLE}</SectionTitle>
        <div className={"nightmares-grid"}>
          <div className={"nightmares-text"}>
            <p>{NIGHTMARES.TEXT}</p>
            <p className={"nightmares-question"}>
              {NIGHTMARES.QUESTION[0]}
              <strong>{NIGHTMARES.QUESTION[1]}</strong>
              {NIGHTMARES.QUESTION[2]}
            </p>
            <SmartLink
              href={NIGHTMARES.BUTTON.href}
              className={"btn"}
            >
              {NIGHTMARES.BUTTON.label}
            </SmartLink>
          </div>
          <img
            src={NIGHTMARES.IMAGE.src}
            alt={NIGHTMARES.IMAGE.alt}
            width={NIGHTMARES.IMAGE.width}
            height={NIGHTMARES.IMAGE.height}
            className={"nightmares-photo"}
            loading={"lazy"}
          />
        </div>
      </div>
    </div>
  </section>
);

export default Nightmares;
